// extracted by mini-css-extract-plugin
export default {"donation_failed":"donation_failed_donation_failed__Eq6yB"};